















import { Component, Vue, Prop } from 'vue-property-decorator';
import { IEpic, IProjectMin } from '@/lib/interfaces';
import { getEpic } from '@/services/api.service';

@Component
export default class EpicRow extends Vue {
  @Prop() private epic!: IEpic;
  // Если нет epic, то сами делаем запрос
  @Prop() private epicId!: string;
  @Prop() private project!: IProjectMin;

  private responseEpic: IEpic | null = null;

  private async mounted() {
    if (this.epicId) {
      this.responseEpic = await getEpic(this.project._id!, this.epicId);
    }
  }

  private get finalEpic(): IEpic {
    return this.epic || this.responseEpic;
  }
}
